module.exports = __webpack_public_path__ + "img/8.ff054ffe.png";